import { OnInit } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { LoanApplicationService } from '../../loan-application.service';
import { EmploymentStatus } from '../../../../@models/employment-status.model';
var CareerDatesComponent = /** @class */ (function () {
    function CareerDatesComponent(loan) {
        var _this = this;
        this.loan = loan;
        this.current_status = this.loan.form.get('current_status');
        this.employment_type = this.loan.form.get('employment_info.employment_type');
        this.employment_channel = this.loan.form.get('employment_info.employment_channel');
        this.looking = EmploymentStatus.KnownStatuses.looking;
        this.pre_employment = EmploymentStatus.KnownStatuses.pre_employment;
        this.done_requirements = EmploymentStatus.KnownStatuses.done_requirements;
        this.balik_manggagawa = EmploymentStatus.KnownStatuses.balik_manggagawa;
        this.working_flyback = EmploymentStatus.KnownStatuses.working_flyback;
        this.working = EmploymentStatus.KnownStatuses.working;
        this.others = EmploymentStatus.KnownStatuses.others;
        this._6monthsAgo = moment().subtract(6, 'months').format('YYYY-MM-DD');
        this._15yearsFromNow = moment().add(15, 'years').format('YYYY-MM-DD');
        this.today = moment().format('YYYY-MM-DD');
        this.invalid = Observable
            .merge(this.current_status.get('started_ofw').valueChanges)
            .startWith(null)
            .map(function () { return _this.current_status.get('started_ofw').invalid; });
    }
    CareerDatesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.current_status.get('unlimited_contract').valueChanges.subscribe(function (value) {
            var datetime_contract_end = _this.current_status.get('datetime_contract_end');
            value ? datetime_contract_end.disable() : datetime_contract_end.enable();
        });
    };
    Object.defineProperty(CareerDatesComponent.prototype, "employment_status", {
        get: function () {
            return this.current_status.get('employment_status').value;
        },
        enumerable: true,
        configurable: true
    });
    return CareerDatesComponent;
}());
export { CareerDatesComponent };
